import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendResetPasswordLink } from '../services/authService';
import { ReactComponent as Logo } from '../assets/logo.svg';
import Loader from './Loader';

const resetPassword = async (email: string) => {
  try {
    console.log('Password reset email sent!');
    alert('Check your email to reset your password.');
  } catch (error) {
    console.error('Error sending password reset email:', error);
    alert('Failed to send password reset email. Please try again.');
  }
};

const PasswordReset: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setErrorMessage('Please enter your email address.');
      return;
    }

    setIsLoading(true);
    const result = await sendResetPasswordLink(email);
    setIsLoading(false);

    if (result.success) {
      setErrorMessage(null); // Clear any previous error
      setSuccessMessage(result.message); // Display success message
    } else {
      setSuccessMessage(null); // Clear any previous success message
      setErrorMessage(result.message); // Display error message
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
      <form onSubmit={handleSubmit}>
      <div className="logo-container">
          <Logo />
        </div>
      <div className="keyword-input-container">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-field"
          required
        />
      </div>
      {errorMessage && <p style={{ color: 'black' }}>{errorMessage}</p>}
      {successMessage && <p style={{ color: 'blue' }}>{successMessage}</p>}
      {isLoading ? <Loader /> : ''}
      <div className="button-container">
        <button disabled={isLoading} className="button button-primary" type="submit">Reset</button>
        <button className="button button-outline" onClick={() => navigate('/')} >
          Login
        </button>

      </div>
    </form>
      </div>
    </div>
  );
};

export default PasswordReset;
